import http from "./http";

import ChampTeam from "./championship/champTeams";
import Squad from "./championship/squad";
import Round from "./championship/rounds";

export default {
  ...ChampTeam,
  ...Squad,
  ...Round,

  index() {
    return http.plainAxiosInstance.get(`/championships`);
  },

  create(newChamp) {
    console.log({ newChamp });

    return http.plainAxiosInstance.post(`/championships`, {
      championship: {
        ...newChamp
      }
    });
  },

  show(champ_id) {
    return http.plainAxiosInstance.get(`/championships/${champ_id}`);
  },

  updateEditionModality(update_EditionModality) {
    return http.plainAxiosInstance.put(
      `/edition_modality/${update_EditionModality.id}`,
      {
        edition_modality: {
          id: update_EditionModality.id
          ////
        }
      }
    );
  },

  //CHAMP TEAM
  showChampTeam(id) {
    return http.plainAxiosInstance.post(`/champ_teams/${id}`);
  },
  createChampTeam(newChampTeam) {
    return http.plainAxiosInstance.post(`/champ_teams`, {
      champ_team: {
        team_attributes: newChampTeam.team_attributes,
        edition_modality_id: newChampTeam.edition_modality_id
      }
    });
  },

  // updateChampTeam(champTeam) {
  //   const { id, group, games_played, points, won, draw, lost, goals_scored, goals_against, goals_difference, red_card, yellow_card, edition_modality_id, team_attributes } = champTeam;
  //   return http.plainAxiosInstance.put(`/champ_teams/${id}`, {
  //     champ_team: {
  //       id,
  //       group,
  //       games_played,
  //       points,
  //       won,
  //       draw,
  //       lost,
  //       goals_scored,
  //       goals_against,
  //       goals_difference,
  //       red_card,
  //       yellow_card,
  //       edition_modality_id,
  //       team_attributes
  //     }
  //   });
  // },

  // SQUADS
  showSquad(id) {
    return http.plainAxiosInstance.post(`/squads/${id}`);
  },

  //ROUNDS
  showRound(id) {
    return http.plainAxiosInstance.post(`/rounds/${id}`);
  },
  createRound(newRound) {
    const {
      name,
      level_configuration_id,
      edition_modality_id,
      status_id,
      kind
    } = newRound;
    return http.plainAxiosInstance.post(`/rounds`, {
      round: {
        name,
        level_configuration_id,
        edition_modality_id,
        status_id,
        kind
      }
    });
  },
  updateRound(round) {
    const {
      id,
      name,
      level_configuration_id,
      edition_modality_id,
      status_id,
      kind
    } = round;
    return http.plainAxiosInstance.put(`/rounds/${id}`, {
      round: {
        id,
        name,
        level_configuration_id,
        edition_modality_id,
        status_id,
        kind
      }
    });
  },

  //EVENTS
  indexEvent(id) {
    return http.plainAxiosInstance.get(`/events/`);
  },

  //MATCHES
  showMatch(id) {
    return http.plainAxiosInstance.get(`/matches/${id}`);
  },
  createMatch(newMatch) {
    const {
      match_date,
      match_time,
      place,
      team_A_id,
      team_B_id,
      round_id,
      status_id
    } = newMatch;
    return http.plainAxiosInstance.post(`/matches`, {
      match: {
        match_date,
        match_time,
        place,
        team_A_id,
        team_B_id,
        round_id,
        status_id
      }
    });
  },
  updateMatch(match) {
    // console.log({ match });

    const {
      id,
      match_date,
      match_time,
      place,
      team_A_id,
      team_B_id,
      round_id,
      status_id,
      winner_id,
      team_a_goals,
      team_a_yellow_cards,
      team_a_red_card,
      team_b_goals,
      team_b_yellow_cards,
      team_b_red_card,
      squad_numbers_attributes,
      papers_attributes,
      match_period,
      match_current_time,
      match_started,
      first_half_done,
      match_ended,
      team_a_fouls,
      team_b_fouls,
      match_concluded,
      match_edited
    } = match;
    return http.plainAxiosInstance.put(`/matches/${id}`, {
      match: {
        id,
        match_date,
        match_time,
        place,
        team_A_id,
        team_B_id,
        round_id,
        status_id,
        winner_id,
        team_a_goals,
        team_a_yellow_cards,
        team_a_red_card,
        team_b_goals,
        team_b_yellow_cards,
        team_b_red_card,
        match_period,
        match_current_time,
        match_started,
        first_half_done,
        match_ended,
        team_a_fouls,
        team_b_fouls,

        match_concluded,
        match_edited,

        squad_numbers_attributes,
        papers_attributes
      }
    });
  },

  updateMatchDetails(match) {
    console.log({ match });

    const {
      id,
      match_date,
      match_time,
      place,
      team_A_id,
      team_B_id,
      round_id,
      status_id
    } = match;
    return http.plainAxiosInstance.put(`/matches/${id}`, {
      match: {
        id,
        match_date,
        match_time,
        place,
        team_A_id,
        team_B_id,
        round_id,
        status_id
      }
    });
  },
  updateMatchTime(match) {
    console.log({ match });

    const {
      id,
      match_period,
      match_current_time,
      match_started,
      first_half_done,
      match_ended,
      team_a_fouls,
      team_b_fouls
    } = match;
    return http.plainAxiosInstance.put(`/matches/${id}`, {
      match: {
        id,
        match_period,
        match_current_time,
        match_started,
        first_half_done,
        match_ended,
        team_a_fouls,
        team_b_fouls
      }
    });
  },

  //PAPER
  showPaper(paper_id) {
    return http.plainAxiosInstance.get(`/papers/${paper_id}`);
  },
  createPaper(paper) {
    const {
      event_time,
      status_id,
      champ_team_id,
      match_id,
      squad_number_id,
      event_id
    } = paper;
    return http.plainAxiosInstance.post(`/papers/`, {
      paper: {
        event_time,
        status_id,
        champ_team_id,
        match_id,
        squad_number_id,
        event_id
      }
    });
  },
  updatePaper(paper) {
    const {
      id,
      event_time,
      status_id,
      champ_team_id,
      match_id,
      squad_number_id,
      event_id
    } = paper;
    return http.plainAxiosInstance.put(`/papers/${id}`, {
      paper: {
        id,
        event_time,
        status_id,
        champ_team_id,
        match_id,
        squad_number_id,
        event_id
      }
    });
  },
  deletePaper(paper) {
    const {
      id,
      event_time,
      status_id,
      champ_team_id,
      match_id,
      squad_number_id,
      event_id
    } = paper;
    return http.plainAxiosInstance.delete(`/papers/${id}`);
  },

  // STATISTICS
  indexStatistics(params) {
    return http.plainAxiosInstance.get(`/statistics/`, {
      params: {
        kind: params.kind, // 0
        id: params.id // 8
      }
    });
  }
};
